import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import PhotoInfo from "../photo-info";

/**
 *  PickerItem
 */
export default class PickerItem extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    pcSrc: PropTypes.string,
    mbSrc: PropTypes.string,
    pcThumbSrc: PropTypes.string,
    mbThumbSrc: PropTypes.string,
    photoInfo: PropTypes.array,
    // extend
    // view / thumbnail 出力 flag - true: view
    showView: PropTypes.bool,
    showMb: PropTypes.bool,
    pickerIndex: PropTypes.number,
    currentPickerIndex: PropTypes.number,
    currentPickerId: PropTypes.string,
    pickerId: PropTypes.string,
    thumbnailClickCaller: PropTypes.func,
    currentFilterId: PropTypes.string,
    filterId: PropTypes.string,
    inCarousel: PropTypes.bool,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    pcDescription: null,
    mbDescription: null,
    pcSrc: null,
    mbSrc: null,
    pcThumbSrc: null,
    mbThumbSrc: null,
    photoInfo: null,
    // extend
    showView: false,
    showMb: false,
    pickerIndex: -1,
    currentPickerIndex: -1,
    currentPickerId: '',
    pickerId: '',
    thumbnailClickCaller: null,
    currentFilterId: '',
    filterId: '',
    inCarousel: false,
  };
  
  /**
   * props / state 比較し update が必要かを判定します
   * @param {*} props React.props
   * @returns {{samePickerIndex: boolean, sameFilterId: boolean}}
   * - samePickerIndex: true current index と my index が同じ
   * - sameFilterId: filterId と currentFilterId が同じ
   */
  static getDerivedStateFromProps(props) {
    const notEmpty = props.currentFilterId !== '';
    const sameFilterId = notEmpty && props.filterId === props.currentFilterId;
    return {
      sameFilterId,
      samePickerIndex: sameFilterId && props.currentPickerIndex === props.pickerIndex,
    }
  }
  
  // ----------------------------------------------------
  constructor(props) {
    super(props);
    // state
    this.state = {
      activateCurrent: props.currentPickerIndex === props.pickerIndex,
      currentPickerIndex: props.currentPickerIndex,
      currentFilterId: props.currentFilterId,
      // thumbPcStyle: { opacity: 0, float: 'left' },
      // thumbMbStyle: { opacity: 0, float: 'left' },
      // thumbPcStyle: { float: 'left' },
      // thumbMbStyle: { float: 'left' },
    };
    this.onClickThumbnail = this.onClickThumbnail.bind(this);
    // this.timer = {
    //   thumbnail: 0,
    //   mount: 0,
    // };
    /**
     * 連打対策のための thumbnail click 可能 flag
     * @type {boolean}
     */
    this.enableThumbnailClick = true;
    // this.onMbLoad = this.onMbLoad.bind(this);
    // this.onPcLoad = this.onPcLoad.bind(this);
  }
  
  // ----------------------------------------------------
  /**
   * thumbnail click event handler
   * - props.thumbnailClickCaller 実行します
   * @param {Event} event click event
   */
  onClickThumbnail(event) {
    event.preventDefault();
    // ---
    // const { activateCurrent } = this.state;
    const { sameFilterId, samePickerIndex } = PickerItem.getDerivedStateFromProps(this.props);
    if (sameFilterId && !samePickerIndex) {
      // current は通知しない
      // 親 component へ click 通知します
      const {thumbnailClickCaller, filterId, pickerIndex} = this.props;
      if (typeof thumbnailClickCaller === 'function') {
        thumbnailClickCaller.call(this, filterId, pickerIndex);
      }
    }
  }
  // onPcLoad() {
  //   this.setState({ thumbPcStyle: null });
  // }
  // onMbLoad() {
  //   this.setState({ thumbMbStyle: null });
  // }
  // activateThumbnailClick() {
  //   // console.log('PickerItem.activateThumbnailClick', Date.now());
  //   this.enableThumbnailClick = true;
  // }
  //
  // abortThumbnailClick() {
  //   clearTimeout(this.timer.thumbnail);
  //   // console.log('PickerItem.abortThumbnailClick', Date.now());
  //   this.enableThumbnailClick = false;
  //   this.timer.thumbnail = setTimeout(() => {
  //     this.activateThumbnailClick();
  //   }, 532);
  // }
  
  // /**
  //  * thumbnail をカレント表示するために update するかを判定します
  //  * - {@link PickerItem.getDerivedStateFromProps}
  //  * @param {*} props React.props
  //  * @param {*} state React.state
  //  */
  // willChangeStateCurrent(props, state) {
  //   const {
  //     showView,
  //     currentFilterId,
  //     currentPickerIndex,
  //   } = this.props;
  //   if (showView) {
  //     return;
  //   }
  //   const { changePickerIndex, samePickerIndex } = PickerItem.getDerivedStateFromProps(props, state);
  //   if (!changePickerIndex) {
  //     return;
  //   }
  //   // if (this.state.activateCurrent !== samePickerIndex) {
  //   //     console.log('PickerItem.willChangeStateCurrent', changePickerIndex, samePickerIndex, this.state, this.props.pickerIndex);
  //   //     this.setState({ activateCurrent: samePickerIndex, currentFilterId, currentPickerIndex  });
  //   // }
  //   this.setState({ activateCurrent: samePickerIndex, currentFilterId, currentPickerIndex });
  // }
  
  // ----------------------------------------------------
  // afterMountUpdateShowThumbnail(delay = 1000) {
  //   const { thumbPcStyle, thumbMbStyle } = this.state;
  //   if (!thumbPcStyle && !thumbMbStyle) {
  //     return;
  //   }
  //   clearTimeout(this.timer.mount);
  //   this.timer.mount = setTimeout(() => {
  //     this.setState({ thumbPcStyle: null, thumbMbStyle: null });
  //   }, delay);
  // }
  // // ----------------------------------------------------
  // componentDidUpdate() {
  //   this.willChangeStateCurrent(this.props, this.state);
  //   // this.afterMountUpdateShowThumbnail();
  // }
  //
  // componentDidMount() {
  //   this.willChangeStateCurrent(this.props, this.state);
  //   // this.afterMountUpdateShowThumbnail();
  // }
  
  // componentWillUnmount() {
  //   // clear timer
  //   Object.values(this.timer).map(id => (clearTimeout(id)));
  // }
  
  // ----------------------------------------------------
  // main - view
  renderPhotoInfo() {
    const {
      photoInfo,
      currentPickerId,
      inCarousel,
    } = this.props;
    // photoInfo 配列内 React.node では無いのでコンバートする
    // if (!Array.isArray(photoInfo) || !photoInfo.length) {
    //     return null;
    // }
    const list = (Array.isArray(photoInfo)) ? photoInfo: [];
    // return photoInfo;
    const filtered = list.filter(component => ((component.name === 'PhotoInfo')));
    if (!filtered.length) {
      return null;
    }
    // 1 件のみ出力
    const component = filtered[0];
    const props = Object.assign({}, component.props);
    return (
      <PhotoInfo
        {...props}
        inHeroCarousel={inCarousel}
        heroCarouselSlideId={currentPickerId}
      />
    );
  }
  
  renderFigures() {
    const {
      pcSrc,
      mbSrc,
    } = this.props;
    if (!pcSrc) {
      return null;
    }
    const mbImg = mbSrc || pcSrc;
    return (
      <div className="PickerItem__photo__block">
        <div className="PickerItem__photo__image">
          <img src={pcSrc} alt="" className="PickerItem__photo__image-pc"/>
          <img src={mbImg} alt="" className="PickerItem__photo__image-mb"/>
        </div>
        {this.renderPhotoInfo()}
      </div>
    );
  }
  
  renderDescriptions() {
    const {
      pcDescription,
      mbDescription,
    } = this.props;
    if (!pcDescription) {
      return null;
    }
    const mbHtml = mbDescription || pcDescription;
    return (
      <div className="PickerItem__Description">
        <div className="PickerItem__pcDescription" dangerouslySetInnerHTML={{__html: pcDescription}}/>
        <div className="PickerItem__mbDescription" dangerouslySetInnerHTML={{__html: mbHtml}}/>
      </div>
    );
  }
  
  renderView() {
    const {
      containerId,
      containerClass,
      pickerId,
      pickerIndex,
      showView,
    } = this.props;
    // ---
    if (!showView) {
      return null;
    }
    // ---
    const renderFigures = this.renderFigures();
    const renderDescriptions = this.renderDescriptions();
    // ---
    if (!renderDescriptions && !renderFigures) {
      return null;
    }
    // ---
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div
          className="PickerItem"
          data-id={`${pickerId}:${pickerIndex}`}
        >
          {renderDescriptions}
          {renderFigures}
        </div>
      </Wrapper>
    )
  }
  
  // ----------------------------------------------------
  // thumbnail
  renderThumbnailMb() {
    const {
      pcThumbSrc,
      mbThumbSrc,
      filterId,
      pickerIndex,
      pcSrc,
      mbSrc,
    } = this.props;
    const pcImg = pcThumbSrc || pcSrc;
    const mbImg = mbThumbSrc || mbSrc;
    const mbThumb = mbImg || pcImg;
    if (!mbThumb) {
      return null;
    }
    // const {
    //   activateCurrent,
    //   // thumbMbStyle,
    // } = this.state;
    // ---
    // const currentClass = activateCurrent ? 'is-active': '';
    const { sameFilterId, samePickerIndex } = PickerItem.getDerivedStateFromProps(this.props);
    const currentClass = (sameFilterId &&  samePickerIndex) ? 'is-active': '';
    // ---
    // console.log('PickerItem.renderThumbnailMb', filterId, pickerIndex, currentPickerIndex, this.state.activateCurrent, currentClass);
    return (
      <div
        className={`PickerItem__thumb__item PickerItem__thumb__item-mb ${currentClass}`}
        role="presentation"
        data-id={filterId}
        data-index={pickerIndex}
        onClick={this.onClickThumbnail}
        data-size="mb"
        // style={thumbMbStyle}
      >
        <span
          className="PickerItem__thumb__item__image"
          style={{backgroundImage: `url(${mbThumb})`}}
        />
      </div>
    );
  }
  
  renderThumbnailPc() {
    const {
      pcThumbSrc,
      filterId,
      pickerIndex,
      pcSrc,
    } = this.props;
    const pcImg = pcThumbSrc || pcSrc;
    // if (!pcThumbSrc) {
    if (!pcImg) {
      return null;
    }
    // const {
    //   activateCurrent,
    //   // thumbPcStyle,
    // } = this.state;
    // ---
    // const currentClass = activateCurrent ? 'is-active': '';
    const { sameFilterId, samePickerIndex } = PickerItem.getDerivedStateFromProps(this.props);
    const currentClass = (sameFilterId &&  samePickerIndex) ? 'is-active': '';
    // console.log('PickerItem.renderThumbnailPc', filterId, currentFilterId, pickerIndex, currentPickerIndex, this.state.activateCurrent, currentClass);
    return (
      <div
        className={`PickerItem__thumb__item PickerItem__thumb__item-pc ${currentClass}`}
        role="presentation"
        data-id={filterId}
        data-index={pickerIndex}
        onClick={this.onClickThumbnail}
        // style={thumbPcStyle}
      >
        <span
          className="PickerItem__thumb__item__image"
          style={{backgroundImage: `url(${pcImg})`}}
          data-id={filterId}
          data-index={pickerIndex}
        />
      </div>
    );
  }
  
  renderThumbnail() {
    const {
      showMb,
      showView,
    } = this.props;
    if (showView) {
      return null;
    }
    return showMb ? this.renderThumbnailMb(): this.renderThumbnailPc();
  }
  
  // ----------------------------------------------------
  render() {
    const {
      showView,
    } = this.props;
    // ---
    const view = this.renderView();
    const thumbnail = this.renderThumbnail();
    // ---
    if (!view && !thumbnail) {
      return null;
    }
    // ---
    // main view と thumbnail container を分ける
    return showView ? view: thumbnail;
  }
  
}




// WEBPACK FOOTER //
// ./src/containers/picker-item/index.jsx